import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ShieldCheck, FileLock2, UserCheck, ArrowRight } from "lucide-react";
import PageHero from "../components/common/PageHero";
import { Button } from "../components/ui/button";
import { useAuth, login } from "../auth/AuthContext";

export default function InvestorAccess() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { document.title = "Investor Access | norse3"; }, []);
  useEffect(() => {
    if (!loading && user) navigate(user.role === "admin" ? "/admin" : "/investor/dashboard", { replace: true });
  }, [loading, user, navigate]);

  return (
    <div>
      <PageHero
        eyebrow="Investor access"
        title="A private, approval-controlled investor room."
        subtitle="Access to the norse3 Information Memorandum and investor pack is gated. Create a secure account, complete the required declarations and request access. Materials are released only to approved investors."
      >
        <Button onClick={login} size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
          <Lock className="mr-1.5 h-4 w-4" /> Sign in / register securely
        </Button>
      </PageHero>

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { icon: UserCheck, t: "1 \u00b7 Create account", d: "Register with a secure sign-in and verified email." },
              { icon: FileLock2, t: "2 \u00b7 Declare & sign", d: "Provide your details, classification and signed declarations." },
              { icon: ShieldCheck, t: "3 \u00b7 Under review", d: "An authorised administrator reviews every application." },
              { icon: Lock, t: "4 \u00b7 Approved access", d: "Only approved investors receive time-limited access." },
            ].map((x) => {
              const Icon = x.icon;
              return (
                <div key={x.t} className="rounded-xl border border-white/10 bg-navy-900/60 p-6">
                  <Icon className="h-6 w-6 text-primary" />
                  <h3 className="mt-4 text-base font-semibold text-foreground">{x.t}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{x.d}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-lg border border-white/10 bg-navy-900/60 p-7">
            <p className="text-sm text-muted-foreground leading-relaxed">
              No Information Memorandum, financial information, presentation, forecast or fundraising
              document is visible or retrievable before approval. This portal does not accept payments
              or binding investment commitments. Indicative capacity is a non-binding indication only.
            </p>
          </div>

          <div className="mt-8">
            <Button onClick={login} className="bg-primary text-primary-foreground hover:bg-primary/90">
              Continue to secure sign-in <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
